"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeybindId = void 0;
var KeybindId;
(function (KeybindId) {
    KeybindId[KeybindId["FULL_RESET"] = 0] = "FULL_RESET";
    KeybindId[KeybindId["YAW_RESET"] = 1] = "YAW_RESET";
    KeybindId[KeybindId["MOUNTING_RESET"] = 2] = "MOUNTING_RESET";
    KeybindId[KeybindId["PAUSE_TRACKING"] = 3] = "PAUSE_TRACKING";
    KeybindId[KeybindId["FEET_MOUNTING_RESET"] = 4] = "FEET_MOUNTING_RESET";
})(KeybindId = exports.KeybindId || (exports.KeybindId = {}));
